
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-api-key",
      function () {
        return require("private-next-pages/account-api-key/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account-api-key"])
      });
    }
  